import { render, staticRenderFns } from "./preSchoolInfo.vue?vue&type=template&id=855c219c&scoped=true&"
import script from "./preSchoolInfo.vue?vue&type=script&lang=js&"
export * from "./preSchoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./preSchoolInfo.vue?vue&type=style&index=0&id=855c219c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855c219c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VLayout,VRow,VSelect,VTextField})
